import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { Theme } from "@infinitaslearning/module-quipu/components/theme";
import { BrowserRouter, useRoutes } from "react-router";
import { GlobalErrorBoundary } from "./global-error-boundary.tsx";
import { ConfigProvider } from "./lib/config/hooks.tsx";
import { getConfig } from "./lib/config/index.ts";
import { ObservabilityProvider } from "./lib/observability/hooks.tsx";
import { observability } from "./lib/observability/index.ts";
import { QueryClientProvider, queryClient, ReactQueryDevtools } from "./lib/react-query/index.ts";
import { routes } from "./routes.tsx";

const config = getConfig();

const { apm } = observability.start({
  environment: config.ilEnv,
  buildVersion: config.buildVersion,
});

function AppRoutes() {
  return useRoutes(routes);
}

// biome-ignore lint/style/noNonNullAssertion: we are sure that root exists
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ObservabilityProvider apm={apm}>
      <ConfigProvider config={config}>
        {/* The assets explorer ships for Plantyn in French (Belgium) only. */}
        <Theme brand="plantyn" locale="fr" user="teacher-general" forcedResponsive="xlarge">
          <GlobalErrorBoundary apm={apm}>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools initialIsOpen={false} />
              <BrowserRouter basename={config.basePath}>
                <AppRoutes />
              </BrowserRouter>
            </QueryClientProvider>
          </GlobalErrorBoundary>
        </Theme>
      </ConfigProvider>
    </ObservabilityProvider>
  </StrictMode>,
);
